import PageTransition from '../components/PageTransition';
import { motion } from 'framer-motion';
import {Link} from "react-router-dom";
import GlassyButton from "../components/GlassyButton";
import Hero from "../components/Hero";
import Why from "../components/Why";
import Process from "../components/Process";
import Reviews from "../components/Reviews";
import AboutBlock from "../components/AboutBlock";
import FAQ from "../components/FAQ";
import {useEffect} from "react";
import Alts from "../components/Alts";

const tg = window?.Telegram?.WebApp;

export default function Home(){

    useEffect(() => {


        tg?.expand();


        tg?.enableClosingConfirmation();
        tg?.disableVerticalSwipes();

        tg?.ready();


    }, []);

    console.log(window.Telegram?.WebApp);
    console.log(window.Telegram?.WebApp?.initDataUnsafe);



    return (
        <PageTransition keyId="home">


            <Hero />

            <Process />

            {/*<Alts />*/}

            <Why />

            <Reviews />

            <FAQ />

            <AboutBlock />


            <div style={{height: '100px'}}>

            </div>


        </PageTransition>
    );
}
